<template>
    <v-container fluid>
        <ApolloQuery
            :query="require('@/graphql/user/allUsers.gql')"
            :variables="{ client_id: client_id, garbage: rando }"
        >
            <template v-slot="{ result: { loading, error, data } }">
                <v-progress-linear indeterminate v-if="loading" />
                <v-alert
                    type="warning"
                    v-if="hasUpdatedProjectNames"
                    dismissible
                >
                    Due to the user deletion, you now own and/or manage the
                    following projects: <br />
                    <strong>{{ updatedProjectNames }}</strong>
                </v-alert>
                <v-data-table
                    v-if="data && !loading"
                    v-model="selected"
                    :items="data.allUsers"
                    :headers="headers"
                    item-key="id"
                    :search="keywords"
                    :items-per-page.sync="itemsPerPage"
                    show-select
                    :footer-props="{ itemsPerPageOptions }"
                >
                    <template v-slot:item.user_type="{ item }">
                        {{ mapUserType(item.user_type) }}
                    </template>
                    <template v-slot:item.last_login="{ item }">
                        {{ item.last_login ? formatDate(item.last_login) : '-' }}
                    </template>
                    <template v-slot:item.last_location="{ item }">
                        {{ item.last_location ?? '-' }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon class="mr-2" @click="editUser(item)">
                            mdi-pencil
                        </v-icon>
                        <v-icon small @click="promptForDelete(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
                <v-alert type="error" v-else-if="error">
                    There was an error loading data. The server said...<br />
                    <strong>{{ error }}</strong>
                </v-alert>
            </template>
        </ApolloQuery>
        <v-dialog
            v-model="deleteDialog"
            persistent
            max-width="320"
            v-if="selectedUser.name != ''"
        >
            <v-card>
                <v-card-title class="headline">Delete User?</v-card-title>
                <v-card-text>
                    <p>
                        You are about to delete the user
                        <strong>{{ selectedUser.name }}</strong
                        >. This cannot be undone. Are you sure you want to
                        delete this user?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red darken-1"
                        text
                        @click="deleteDialog = false"
                        >{{ $t('cancel') }}</v-btn
                    >
                    <v-btn
                        color="primary darken-1"
                        text
                        @click="deleteUser(selectedUser)"
                        >{{ $t('delete') }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from 'moment/moment'

export default {
    name: 'UsersGrid',
    props: {
        keywords: {
            type: String,
            required: true,
        },
        reload: {
            type: Number,
            default: 0,
        },
        client_id: {
            type: String,
        },
    },
    data: () => ({
        itemsPerPageOptions: [25, 50, 100],
        itemsPerPage: 25,
        deleteDialog: false,
        hasUpdatedProjectNames: false,
        updatedProjectNames: '',
        selectedUser: {},
        selected: [],
        rando: 0,
        headers: [
            {
                text: 'Name',
                align: 'left',
                value: 'name',
            },
            { text: 'Email', value: 'email' },
            { text: 'Type', value: 'user_type' },
            { text: 'Client', value: 'client.name' },
            { text: 'Last Login', value: 'last_login' },
            { text: 'Last Location', value: 'last_location' },
            {
                text: 'Actions',
                align: 'right',
                sortable: false,
                value: 'action',
            },
        ],
    }),
    watch: {
        reload: function(val) {
            this.rando = val
        },
    },
    methods: {
        formatDate(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format(
                'MM/DD/YYYY hh:mm A'
            )
        },

        mapUserType(type) {
            if (type === 'admin') {
                return 'Administrator'
            } else if (type === 'client_admin') {
                return 'Company Administrator'
            } else {
                return 'Company User'
            }
        },

        promptForDelete(user) {
            this.selectedUser = user
            this.deleteDialog = true
        },

        async deleteUser(user) {
            this.$apollo
                .mutate({
                    // Query
                    mutation: require('@/graphql/user/deleteUser.gql'),
                    // Parameters
                    variables: {
                        id: user.id,
                    },
                })
                .then(({data}) => {
                    if (data.deleteUser.success) {
                        this.hasUpdatedProjectNames = data.deleteUser.projects.length > 0;
                        this.updatedProjectNames = data.deleteUser.projects.join(', ');
                    } else {
                        this.hasUpdatedProjectNames = false;
                        this.updatedProjectNames = '';
                    }

                    // report success
                    this.$emit('user-form-closed', data.deleteUser)
                    this.rando++
                })
                // eslint-disable-next-line no-unused-vars
                .catch(error => {
                    // Error
                    // update user....
                })
            this.deleteDialog = false
        },
        editUser(user) {
            this.$emit('edit-user', user)
        },
    },
}
</script>
